module.exports = __webpack_public_path__ + "img/avatar.a3868c8a.png";